import { SimulationEndpoints, WalletEndpoints } from '@/services/shared/ApiEndpoints';
import { BaseService } from '@/services/shared/BaseService';
import { ListSelectService } from '@/services/shared/ListSelectService';
import { ApiListResponse, ListRequestGlobalProps, NotificationType } from '@/types/Common';
import { Wallet } from '@/types/Wallet';
import { API } from '@/utils/api';
import { notify } from '@/utils/notify';
import { PUBLIC_URL } from '@/utils/url';
import { validateQueryParamId } from '@/utils/validate-query-params';

class WalletService {
  async fetchWallet(params: ListRequestGlobalProps): Promise<ApiListResponse<Wallet>> {
    return await BaseService.fetchList<Wallet>(WalletEndpoints.BASE, params);
  }

  async getWallets(): Promise<ApiListResponse<Wallet>> {
    return await ListSelectService.fetchList<Wallet>(WalletEndpoints.BASE);
  }

  async getWallet(walletId: any): Promise<Wallet> {
    const validatedId = validateQueryParamId(walletId);
    if (!validatedId) {
      throw new Error('Invalid wallet ID');
    }
    try {
      const response = await API.get<Wallet>(WalletEndpoints.WALLET_BY_ID(validatedId));
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async exportToExcel(simulationData: any): Promise<void> {
    const fetchURL = new URL(SimulationEndpoints.WALLET_EXPORT, PUBLIC_URL);
    try {
      const response = await API.post(fetchURL.href, simulationData, {
        responseType: 'blob',
      });
      // Generate the file name based on agreement ID
      const agreementId = simulationData.agreement || 'portfel';
      const fileName = `portfel_${agreementId}.xlsx`;
      const blob = new Blob([response.data]);
      const fileUrl = window.URL.createObjectURL(blob);
      this.downloadFile(fileUrl, fileName);
      window.URL.revokeObjectURL(fileUrl);
      notify(NotificationType.SUCCESS, 'Plik Excel został wygenerowany i pobrany.');
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.message || 'Wystąpił błąd podczas generowania pliku Excel.';
      console.error('Error exporting Excel:', error);
      notify(NotificationType.ERROR, errorMessage);
    }
  }

  private downloadFile(fileUrl: string, fileName: string): void {
    const link = document.createElement('a');
    link.href = fileUrl;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
}

const instance = new WalletService();
export { instance as WalletService };
